const invitationLinks = {
  root: () => '/invitations',
  accept: ({ invitationId }: { invitationId: string }) =>
    `/invitations/${invitationId}`,
};

export default invitationLinks;
